"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonOrLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sdsButtons_module_css_1 = __importDefault(require("./sdsButtons.module.css"));
/**
 * ButtonOrLink contains the logic that will determine whether a
 * <button /> or <a /> node is rendered
 */
function ButtonOrLink(props) {
    const children = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [props.icon && (0, jsx_runtime_1.jsx)("span", { className: sdsButtons_module_css_1.default.buttonIcon, children: props.icon }), props.children] }));
    const propsWithIcon = {
        ...props,
        children,
    };
    return props.link ? ((0, jsx_runtime_1.jsx)("a", { ...propsWithIcon, href: props.link, "data-testid": props.dataTest, target: props.openLinkInNewTab ? "_blank" : undefined })) : ((0, jsx_runtime_1.jsx)("button", { type: "button", ...propsWithIcon, "data-testid": props.dataTest }));
}
exports.ButtonOrLink = ButtonOrLink;
//# sourceMappingURL=sdsButtons.js.map